import {
  buildSearchAvtoSeoTitle,
  buildSearchMotoSeoTitle,
  buildDealersSeoTitle,
  buildSparePartsSeoTitles,
  buildFirmsSeoTitle,
  buildFirmPageSeoTitle,
  buildSearchCommercialSeoTitle,
} from 'shared/helpers/seoTitles';
import { getCustomParams } from 'shared/helpers/seoTextFinder/seoDataFinder';

const getLocationString = (location, t) =>
  location && location.title ? `${t('в ')} ${location.title}` : t('в Украине');

const buildAddTitleByTransportSlug = (slug, t) => {
  let transportTitle = 'авто';
  let transportSecondTitle = 'автомобиля';
  switch (slug) {
    case 'avto': {
      transportTitle = 'авто';
      transportSecondTitle = 'автомобиля';
      break;
    }
    case 'moto': {
      transportTitle = 'мототехнику';
      transportSecondTitle = 'мототехники';
      break;
    }
    case 'avtobus': {
      transportTitle = 'автобус';
      transportSecondTitle = 'автобуса';
      break;
    }
    case 'gruzovye': {
      transportTitle = 'грузовое авто';
      transportSecondTitle = 'грузового автомобиля';
      break;
    }
    case 'spetstehnika': {
      transportTitle = 'спецтехнику';
      transportSecondTitle = 'спецтехники';
      break;
    }
    case 'pritsepy': {
      transportTitle = 'прицеп';
      transportSecondTitle = 'прицепа';
      break;
    }
    case 'vodnyi-transport': {
      transportTitle = 'водный транспорт';
      transportSecondTitle = 'водного транспорта';
      break;
    }
    case 'zapchasti': {
      transportTitle = 'запчасти';
      transportSecondTitle = 'автозапчастей';
      break;
    }

    default: {
      break;
    }
  }

  return `${t('Продать')} ${t(transportTitle).toLowerCase()} на АвтоБазар™ - ${t(
    'подать объявление о продаже',
  )} ${t(transportSecondTitle).toLowerCase()} на avtobazar.ua`;
};

const TITLE = {
  HOME: (props, t) => t('SEO_HOME_TITLE'),

  ADVERT: (
    {
      id,
      make,
      model,
      modification,
      year,
      price,
      mileage,
      location,
      isNew = false,
      dealer = false,
    },
    transportTitle = '',
    t,
  ) => {
    const { inCity } = getCustomParams({ city: location.title }, t) || '';
    const transportTitles = [
      'Мотоцикл',
      'Скутер',
      'Квадроцикл',
      'Мопед',
      'Баггі',
      'Багги',
      'Трицикл',
      'Грузовые',
      'Автобусы',
      'Прицепы',
      'Водный транспорт',
      'Спецтехника',
    ];

    if (transportTitles.includes(transportTitle)) {
      return [
        t('Купить'),
        t(transportTitle),
        make && make.title,
        model && model.title,
        modification && modification.title,
        year,
        `в ${t(location.title)}`,
        dealer && dealer.title && `${t('в автосалоне')} ${dealer.title}`,
        mileage &&
          `${t('с пробегом')} ${t(mileage).slice(0, -7)} ${
            t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'
          }`,
        price && `${t('цена')} ${price}`,
        t('на Автобазаре'),
        isNew && ` - ${t('Новый').toLowerCase()}`,
        id && `(${id})`,
      ]
        .filter(i => !!i)
        .join(' ');
    }

    return [
      t('Купить'),
      !isNew && transportTitle,
      /* transportNextTitle, */
      make && make.title,
      model && model.title,
      modification && modification.title,
      year,
      inCity,
      isNew && dealer && dealer.title && `${t('в автосалоне')} ${dealer.title}`,
      mileage && `${t('с пробегом')} ${t(mileage).slice(0, -7)} ${t('тыс км')}`,
      price && `${t('цена')} ${price}`,
      id && `(${id})`,
      t('- Автобазар'),
    ]
      .filter(i => !!i)
      .join(' ');
  },
  // ...

  SPARE_ADVERT: ({ id, rubric, sparetype, type, make, model, price, location }, t) =>
    [
      t('Купить'),
      rubric && rubric.title,
      sparetype && (sparetype.title || '').toLowerCase(),
      (type || make || model) && t('на'),
      type && (type.title || '').toLowerCase(),
      make && make.title,
      model && model.title,
      getLocationString(location, t),
      price && `${t('цена')} ${price}`,
      t('на Автобазаре'),
      id && `- ${id}`,
    ]
      .filter(i => !!i)
      .join(' '),
  //

  SEARCH: {
    avto: (data, t) => buildSearchAvtoSeoTitle(data, t),
    moto: (data, t) => buildSearchMotoSeoTitle(data, t),
    mototsikl: ({ make = '', model = '', category, type, location, motoTitle, yearTitle }, t) =>
      [
        t('Купить'),
        ...(make
          ? [motoTitle || t('мотоцикл'), make && make.title, model && model.title]
          : [`${type && type.title ? type.title.toLowerCase() : ''}`]),
        category && category.title ? category.title.toLowerCase() : '',
        `${yearTitle}${location || t('в Украине')}:`,
        t('б/у и новая мототехника на АвтоБазар™'),
      ]
        .filter(i => !!i)
        .join(' '),
    commercial: (params, t) => buildSearchCommercialSeoTitle(params, t),
  },
  //

  SPARE_PARTS: (data, rubricSlug, t) => buildSparePartsSeoTitles(data, rubricSlug, t),

  FIRM: (data, t) => buildFirmsSeoTitle(data, t),

  FIRM_PAGE: (title, tab, t, car_drive_countries, tags) =>
    buildFirmPageSeoTitle(title, tab, t, car_drive_countries, tags),

  //

  DEALERS: (data, slug, t) => buildDealersSeoTitle(data, slug, t),

  DEALER_PAGE: {
    ADVERTS: (dealer = '', t) =>
      `${dealer} - ${t('все предложения автосалона с ценами и фото на сайте Автобазар')}`,

    NEWS: (dealer = '', t) =>
      `${t('Новости и акции автосалона')} ${dealer} ${t('на сайте Автобазар')}`,

    ABOUT: (dealer = '', t) =>
      `${t('Информация об автосалоне')} ${dealer}: ${t('все о компании на АвтоБазаре')}`,

    CONTACT: (dealer = '', t) =>
      `${t('Контакты автосалона')} ${dealer}: ${t(
        'адреса, контактный номер телефона, официальный сайт',
      )}`,
  },

  //

  INVOICE: t => t('Квитанция за оплату'),

  //

  JOURNAL: {
    ALL: t => t('Все новости и статьи на Автобазар'),
    NEWS: (t, rubric) =>
      `${t('Все')} ${t(rubric || 'Новости').toLowerCase()} ${t('на Автобазаре')}`,
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: t => `${t('Оценка стоимости авто')} ${t('на Автобазаре')}`,
    CAR_DRIVE: t => `${t('Пригон авто')} ${t('на Автобазаре')}`,
    SEARCH_SUBSCRIPTIONS: t => `${t('Подписка на поиск')} ${t('на Автобазаре')}`,
  },

  //

  LOGIN: t => t('Войти в Автобазар'),

  //

  NOT_FOUND: t => t('Страница не найдена'),

  //

  ADVERT_FORM: {
    ADD: (slug, t) => buildAddTitleByTransportSlug(slug, t),
    EDIT: t => t('Редактировать объявление'),
  },

  //

  PROFILE: {
    PROFILE: t => t('Мой профиль'),
    DIALOGS: t => t('Мои сообщения'),
    FAVORITES: t => t('Мои избранные'),
    BILLING: t => t('Мой баланс'),
    SEARCHES: t => t('Мои поиски'),
    ADVERTS: t => t('Мои объявления'),
    INSURANCE: t => t('Страховка'),
    SEARCH_SUBSCRIPTIONS: t => t('Подписка на поиск'),
  },

  //

  MOBILE_FORM: {
    GEO: t => t('Выбор местоположения'),
    FILTERS: t => t('Выбор по параметрам'),
  },

  STATIC_PAGE: {
    LAW: t => `${t('Справка Автобазар:')} ${t('Политика конфиденциальности')}`,
    INFO_ZAPCHASTI: t => `${t('Справка Автобазар:')} ${t('Запчасти')}`,
    HELP: t => `${t('Справка Автобазар:')} ${t('Помощь')}`,
    FOR_SERVICES: t => `${t('Справка Автобазар:')} ${t('Автосервисам')}`,
    FOR_PRIVATES: t => `${t('Справка Автобазар:')} ${t('Размещение объявлений')}`,
    FOR_DEALERS: t => `${t('Справка Автобазар:')} ${t('Пакет “Бизнес Плюс”')}`,
    BIZNES_PAKET: t => `${t('Справка Автобазар:')} ${t('Пакет “Бизнес”')}`,
    ADVERTISING: t => `${t('Справка Автобазар:')} ${t('Разместить рекламу')}`,
    ABOUT: t => `${t('Справка Автобазар:')} ${t('Что такое автобазар')}`,
    FAQ: t => `${t('Справка Автобазар:')} ${t('Часто задаваемые вопросы')}`,
    ENTRANCE: t => `${t('Справка Автобазар:')} ${t('Регистрация на avtobazar.ua')}`,
    TRANSPORT_ADS_RULES: t => `${t('Справка Автобазар:')} ${t('Правила составления объявлений')}`,
    PUBLIC_CONTRACT: t => `${t('Справка Автобазар:')} ${t('Публичный договор')}`,
  },
};

export default TITLE;



// WEBPACK FOOTER //
// ./src/shared/constants/seoTitles.js